/**
 * Web.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ApplicationDataImportEntityImportResult { 
    inserted?: number;
    updated?: number;
    deleted?: number;
    ignored?: number;
    readonly insertErrors?: { [key: string]: string; } | null;
    readonly updateErrors?: { [key: string]: string; } | null;
    readonly deleteErrors?: { [key: string]: string; } | null;
}

